import { useQuery } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'

export const GET_CUSTOMERS_QUERY_KEY = 'get-customers'

export const useGetCustomers = (params?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [GET_CUSTOMERS_QUERY_KEY] as const,
    queryFn: async () => {
      const { data, error } = await supabaseApi.from('customers').select('*')

      if (error) throw error
      return data
    },
    enabled: params?.enabled,
  })
}
